import { useLingui } from '@lingui/react/macro';
import Selector from 'modules/template-editor/ui/components/elements/selector';
import React, { useMemo } from 'react';
import FontLoadWarning from 'shared/components/font-load-warning';
import { findFontOption, fontPickerOptions, missingFontLabel, withCurrentFont } from 'shared/fonts';

interface FontFamilySelectProps {
  /** Значение объекта: CSS-стек (`"Oswald", sans-serif`) или старое `Open Sans, sans-serif`. */
  value: string | undefined;
  /** Начертание объекта — для предупреждения «шрифт не загрузился». */
  fontWeight?: string | number;
  /** Получает стек из реестра. */
  onChange: (stack: string) => void;
  onFocus?: () => void;
}

const STACK_OPTIONS = fontPickerOptions('stack');

/**
 * Выбор шрифта редактора трансляций — общий список реестра (`shared/fonts`), тот же, что у
 * медиа-менеджера. Управляемый (`value`, не `defaultValue`): инспектор не перемонтируется при
 * переходе с объекта на объект, и неуправляемый селект показывал шрифт предыдущего объекта.
 * Шрифт старой схемы вне набора показывается пунктом «… — нет в наборе», а не пустым селектом.
 */
function FontFamilySelect({ value, fontWeight, onChange, onFocus }: FontFamilySelectProps) {
  const { t } = useLingui();
  const options = useMemo(
    () => (value ? withCurrentFont(STACK_OPTIONS, value, t(missingFontLabel(value))) : STACK_OPTIONS),
    [t, value],
  );

  return (
    <div className="flex items-center gap-1.5">
      <div className="min-w-0 flex-1">
        <Selector
          styledEachOption
          onFocus={onFocus}
          onChange={(option) => {
            if (option?.value) onChange(option.value);
          }}
          options={options}
          value={findFontOption(options, value) ?? null}
        />
      </div>
      <FontLoadWarning fontFamily={value} fontWeight={fontWeight} />
    </div>
  );
}

export default FontFamilySelect;
